import { useLocationMarker } from '../hooks';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { Loader2, LocateFixed } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const LocationMarker = () => {
    const { t } = useTranslation();
    const { loading, handleLocate } = useLocationMarker();

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        type="button"
                        onClick={handleLocate}
                        size="icon"
                        variant="outline"
                        className="h-8 w-8 rounded-full shadow-md"
                        disabled={loading}
                    >
                        {loading ? (
                            <Loader2 className="h-4 w-4 animate-spin" />
                        ) : (
                            <LocateFixed className="h-4 w-4" />
                        )}
                    </Button>
                </TooltipTrigger>
                <TooltipContent side="left">
                    {t('properties.location.findMyLocation')}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};